import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Link } from 'react-router-dom';
import NavBar from './components/NavBar';
import MovieDetail from './MovieDetail';
import FilmPage from './FilmPage';
import TheaterDetail from './TheaterDetail';
import Changelog from './Changelog';
import FAQ from './FAQ';
import Watchlist from './pages/Watchlist';
import Profile from './pages/Profile';
import FormatPage from './pages/FormatPage';
import FilmClubs from './pages/FilmClubs';
import Venues from './pages/Venues';
import Support from './pages/Support';
import NotFound from './pages/NotFound';
import FilmClub from './pages/FilmClub';
import FilmClubEvent from './pages/FilmClubEvent';
import SubmitScreening from './pages/SubmitScreening';
import './MovieDetail.css'; // or './App.css'
import './App.css'; // <-- import the stylesheet
import { FilmRevival } from './FilmRevival/index';
import { AuthProvider } from './contexts/AuthContext';

// Initialize GA
const TRACKING_ID = "G-WWNQX4K009";

// Define gtag as a global function
window.dataLayer = window.dataLayer || [];
function gtag(){window.dataLayer.push(arguments);}
window.gtag = gtag;

// Site nav on EVERY page (9/2 QA: "venues needs a back to showtimes button" —
// the nav only existed on the calendar, so sub-pages were dead ends). The
// calendar renders its own full masthead, so this skips "/" to avoid doubling.
function GlobalNav() {
  const { pathname } = useLocation();
  if (pathname === '/') return null;
  // Film + movie detail pages keep the wordmark but drop the menu row (9/2,
  // Josh: "looks cluttered") — they already carry their own "return to
  // homepage" link, and the page is about ONE film, not the site's sections.
  const isDetail = pathname.startsWith('/films/') || pathname.startsWith('/movie/');
  return (
    <header className="app-title" style={{ textAlign: 'center', margin: '26px 0 10px', position: 'relative' }}>
      <Link to="/" style={{ textDecoration: 'none' }}>
        <h1 style={{ marginBottom: '4px' }}>Film Revival NYC</h1>
      </Link>
      <div style={{ width: '48px', height: '2px', background: '#d4a843', margin: '8px auto 10px', borderRadius: '1px' }} />
      {!isDetail && <NavBar />}
    </header>
  );
}

function App() {
  useEffect(() => {
    // Load the GA script
    const script1 = document.createElement('script');
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${TRACKING_ID}`;
    script1.async = true;
    document.head.appendChild(script1);

    // Initialize GA
    gtag('js', new Date());
    gtag('config', TRACKING_ID);
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <GlobalNav />
        <Routes>
          <Route path="/" element={<FilmRevival />} />
          <Route path="/movie/:movieId" element={<MovieDetail />} />
          <Route path="/films/:slug" element={<FilmPage />} />
          <Route path="/theater/:theaterSlug" element={<TheaterDetail />} />
          <Route path="/changelog" element={<Changelog />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/watchlist" element={<Watchlist />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/35mm-nyc" element={<FormatPage />} />
          <Route path="/venues" element={<Venues />} />
          <Route path="/support" element={<Support />} />
          <Route path="/film-clubs" element={<FilmClubs />} />
          <Route path="/film-clubs/club/:clubSlug" element={<FilmClub />} />
          <Route path="/film-clubs/:eventId" element={<FilmClubEvent />} />
          <Route path="/submit-screening" element={<SubmitScreening />} />
          {/* Catch-all: unknown paths get a real 404 page + noindex instead of
              a homepage clone (9/4 SEO audit). */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;